import {
  getReq,
  postReq,
  postFormData,
  patchReq,
  deleteReq,
  getById
} from "../../../services/api";

const state = {
  allEquipments: [],
  equipmentDocuments: [],
  currentEquipment: null,
  currentMaintenance: {},
  currentMaintenanceSchedule: {},
  maintenance: [],
  maintenanceSchedule: [],
  types: [],
  vendors:[]
};

const getters = {
  allEquipments: (state) => state.allEquipments,
  equipmentDocuments: (state) => state.equipmentDocuments,
  currentEquipment: (state) => state.currentEquipment,
  maintenance: (state) => state.maintenance,
  maintenanceSchedule: (state) => state.maintenanceSchedule,
  currentMaintenance: (state) => state.currentMaintenance,
  currentMaintenanceSchedule: (state) => state.currentMaintenanceSchedule,
  types: (state) => state.types,
  vendors: (state) => state.vendors
};

const actions = {
  async getAllEquipments({ commit }, url) {
    try {
      const data = await getReq(`app/equipment/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      commit("setAllEquipments", data.equipment);
      return { records: data.equipment, total_pages: data.total_pages, queryset_count: data.queryset_count, total_entries: data.total_entries_count, current_page: data.current_page, total_active_count: data.total_active_count, total_inactive_count: data.total_inactive_count }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
    async getFilteredEquipments(_, {unit_no, type = null, status = null, noTireRecords = false}) {
    try {
      const data = await getReq(`app/search-equipment-by-unit-numbers/?unit_no=${unit_no}${type ? `&type=${type}` : ''}${status ? `&status=${status}` : ''}${noTireRecords ? `&no_tire_records=${noTireRecords}` : ''}`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
  async getEquipment({ commit }, id) {
    try {
      const currentEquipment = await getReq(`app/equipment/${id}/${localStorage.getItem("userSelectedCompany") ? `?company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      commit("setCurrentEquipment", currentEquipment);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
  async searchEquipment(_, query) {
    try {
      return await getReq(`app/search-equipment/?${query}`);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response;
    }
  },
  async getEquipmentsExportData(_, query) {
    try {
      return await getReq(`app/export_excel_equipment/${query ? "?" + query : ''}${localStorage.getItem("userSelectedCompany") ? `${query ? '&' : ''}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response;
    }
  },
  async getEquipmentCount(_, query) {
    try {
      const data = await getReq(
        `app/equipment_count/?equipment_choice=${query}${localStorage.getItem("userSelectedCompany") ? `&company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`
      );
      return data;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response;
    }
  },
  async addEquipment(context, payload) {
    try {
      const newMember = await postReq(`app/equipment/`, payload);

      return newMember;
      // get all team member again
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response.data;
    }
  },
  async getCompanyEquipmentDetails(_, payload) {
    try {
      const { data } = await postReq(`app/get-equipment-details/`, payload);
      return data
    } catch (error) {
            if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
  async updateEquipment({ commit }, { id, payload }) {
    try {
      const updatedEquipment = await patchReq("app/equipment", id, payload);
      if (updatedEquipment) {
        commit("setCurrentEquipment", updatedEquipment);
      }
      return updatedEquipment
    } catch (e) {
      if (!e.response) {
        throw "No network connection";
      }
      if (e.response && e.response.status === 500) {
        throw "Internal server error";
      }
      if (e.response && e.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = e.response.data;
      
      throw errors;
    }
  },
  async sendEquipmentDocument(_, formData) {
    try {
      const data = await postFormData("app/documents/", formData);
      return data;
    } catch (e) {
      if (!e.response) {
        throw "No network connection";
      }
      if (e.response && e.response.status === 500) {
        throw "Internal server error";
      }
      if (e.response && e.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = e.response.data;
      
      throw errors;
    }
  },
  async getAllTypes({ commit }, id) {
    try {
      const {data} = await getReq(`app/types/?company_id=${id}` );
      commit("setTypes", data.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())));
    } catch (error) {
            if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
    }
  },
  
  async addType(_, payload) {
    try {
     await postReq(`app/types/`, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response.data;
    }
  },
  async deleteType(_, id) {
    try {
      return await deleteReq("app/types", id);
    } catch (error) {
            if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
  async updateType(_, { id, payload }) {
    try {
      return await patchReq("app/types", id, payload);
    } catch (error) {
            if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response.data;
    }
  },
  async addVendor(_, payload) {
    try {
     await postReq(`app/maintenance-vendors/`, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response.data;
    }
  },
  async deleteVendor(_, id) {
    try {
      return await deleteReq("app/maintenance-vendors", id);
    } catch (error) {
            if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
  async updateVendor(_, { id, payload }) {
    try {
      return await patchReq("app/maintenance-vendors", id, payload);
    } catch (error) {
            if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response.data;
    }
  },
  async getAllVendors({commit}, url) {
    try {
      const data = await getReq(`app/maintenance-vendors/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      commit("setVendors", data.data);
      return { records: data.data, total_pages: data.total_pages, queryset_count: data.queryset_count, total_entries: data.total_entries_count, current_page: data.current_page,total_amount:data.total_amount }
    } catch (error) {
            if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
    }
  },
  async sendMaintenanceDocument(_, {formData, id}) {
    try {
      return await postFormData(`app/maintenance/${id}/documents/?company_id=${localStorage.getItem("userSelectedCompany")}`, formData);
    } catch (e) {
      if (!e.response) {
        throw "No network connection";
      }
      if (e.response && e.response.status === 500) {
        throw "Internal server error";
      }
      if (e.response && e.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = e.response.data;
      
      throw errors;
    }
  },
  
  async updateMaintenanceDocument(_, {formData, id, doc}) {
    try {
      return await patchReq(`app/maintenance/${id}/documents`, doc,formData);
    } catch (e) {
      if (!e.response) {
        throw "No network connection";
      }
      if (e.response && e.response.status === 500) {
        throw "Internal server error";
      }
      if (e.response && e.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = e.response.data;
      
      throw errors;
    }
  },
  async retrieveMaintenanceDocument(_, {id, doc}) {
    try {
      return await getById(`app/maintenance/${id}/documents/`, doc);
    } catch (e) {
      if (!e.response) {
        throw "No network connection";
      }
      if (e.response && e.response.status === 500) {
        throw "Internal server error";
      }
      if (e.response && e.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = e.response.data;
      
      throw errors;
    }
  },
  async deleteMaintenanceDocument(_,{id, doc}) {
    try {
      return await deleteReq(`app/maintenance/${id}/documents`, doc);
    } catch (e) {
      if (!e.response) {
        throw "No network connection";
      }
      if (e.response && e.response.status === 500) {
        throw "Internal server error";
      }
      if (e.response && e.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = e.response.data;
      
      throw errors;
    }
  },

  async getMaintenanceLineItems(_, maintenanceId) {
    try {
      return await getReq(`app/maintenance/${maintenanceId}/line-items/`);
    } catch (e) {
      if (!e.response) {
        throw "No network connection";
      }
      if (e.response && e.response.status === 500) {
        throw "Internal server error";
      }
      if (e.response && e.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = e.response.data;
      
      throw errors;
    }
  },

  async addMaintenanceLineItem(_, { maintenanceId, payload }) {
    try {
      return await postReq(`app/maintenance/${maintenanceId}/line-items/`, payload);
    } catch (e) {
      if (!e.response) {
        throw "No network connection";
      }
      if (e.response && e.response.status === 500) {
        throw "Internal server error";
      }
      if (e.response && e.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = e.response.data;
      
      throw errors;
    }
  },

  async updateMaintenanceLineItem(_, { maintenanceId, itemId, payload }) {
    try {
      return await patchReq(`app/maintenance/${maintenanceId}/line-items`, itemId, payload);
    } catch (e) {
      if (!e.response) {
        throw "No network connection";
      }
      if (e.response && e.response.status === 500) {
        throw "Internal server error";
      }
      if (e.response && e.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = e.response.data;
      
      throw errors;
    }
  },

  async deleteMaintenanceLineItem(_, { maintenanceId, itemId }) {
    try {
      return await deleteReq(`app/maintenance/${maintenanceId}/line-items`, `${itemId}/`);
    } catch (e) {
      if (!e.response) {
        throw "No network connection";
      }
      if (e.response && e.response.status === 500) {
        throw "Internal server error";
      }
      if (e.response && e.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = e.response.data;
      
      throw errors;
    }
  },

  async deleteEquipment(_, id) {
    try {
      return await deleteReq("app/equipment", id);
    } catch (e) {
      if (!e.response) {
        throw "No network connection";
      }
      if (e.response && e.response.status === 500) {
        throw "Internal server error";
      }
      if (e.response && e.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = e.response.data;
      
      throw errors;
    }
  },

  async updateEquipmentDocument(_, { id, payload }) {
    try {
      return await patchReq("app/documents", id, payload);
    } catch (e) {
      if (!e.response) {
        throw "No network connection";
      }
      if (e.response && e.response.status === 500) {
        throw "Internal server error";
      }
      if (e.response && e.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = e.response.data;
      
      throw errors;
    }
  },
  async addBulkEquipmentsDocument(_, payload) {
    try {
      return await postReq("app/add-equipment-documents-bulk/", payload);
    } catch (e) {
      if (!e.response) {
        throw "No network connection";
      }
      if (e.response && e.response.status === 500) {
        throw "Internal server error";
      }
      if (e.response && e.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = e.response.data;
      
      throw errors;
    }
  },
  async updateEquipmentStatus(context, payload) {
    try {
      const newEquipment = await postReq(`app/change-equipment-status/`, payload);
      return newEquipment;
      // get all team member again
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response.data;
    }
  },
  async deleteEquipmentDocument(_, id) {
    try {
      return await deleteReq("app/documents", id);
    } catch (e) {
      if (!e.response) {
        throw "No network connection";
      }
      if (e.response && e.response.status === 500) {
        throw "Internal server error";
      }
      if (e.response && e.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = e.response.data;
      
      throw errors;
    }
  },
  async getMaintenance({ commit }, url) {
    try {
      const data = await getReq(`app/maintenance/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      commit("setMaintenance", data.data);
      return { records: data.data, total_pages: data.total_pages, queryset_count: data.queryset_count, total_entries: data.total_entries_count, current_page: data.current_page,total_amount:data.total_amount }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
  async getMaintenanceSchedule({ commit }, url) {
    try {
      const data = await getReq(`app/maintenance-schedule/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      commit("setMaintenanceSchedule", data.data);
      return { records: data.data, total_pages: data.total_pages, queryset_count: data.queryset_count, total_entries: data.total_entries_count, current_page: data.current_page }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
  async getMaintenanceTotal(_,url) {
    try {
      const data = await getReq(`app/maintenance-total/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      return { records: data.data, total_pages: data.total_pages, queryset_count: data.queryset_count, total_entries: data.total_entries_count, current_page: data.current_page,total_amount:data.counts.total_amount, total_miles: data.counts.total_miles, cost_per_mile: data.counts.cost_per_mile, total_amount_change_percentage: data.counts.total_amount_change_percentage, cost_per_mile_change_percentage: data.counts.cost_per_mile_change_percentage, total_miles_change_percentage: data.counts.total_miles_change_percentage, equipment_repairs: data.counts.equipment_repairs || 0,  equipment_repairs_change_percentage: data.counts.equipment_repairs_change_percentage || 0, total_repairs: data.counts.total_repairs || 0, total_repairs_change_percentage: data.counts.total_repairs_change_percentage || 0 }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
  async getMaintenanceRecordsExportData(_, query) {
    try {
      return await getReq(`app/maintenance/export_to_csv/${query ? "?"+query : ''}${localStorage.getItem("userSelectedCompany") ? `${query ? '&':''}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response;
  }
},
async getMaintenanceTotalRecordsExportData(_, query) {
  try {
    return await getReq(`app/maintenance-total/export_to_csv/${query ? "?"+query : ''}${localStorage.getItem("userSelectedCompany") ? `${query ? '&':''}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
  } catch (error) {
    if (error.response && error.response.status === 403) {
      throw "You are not allowed to perform this action.";
    }
    throw error.response;
}
},
async getRecurringSchedule(_, url) {
  try {
    const data = await getReq(`app/recurring-maintenance-schedule/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
    return { records: data.data, total_pages: data.total_pages, queryset_count: data.queryset_count, total_entries: data.total_entries_count, current_page: data.current_page,total_amount:data.total_amount }
  } catch (error) {
    if (error.response && error.response.status === 403) {
      throw "You are not allowed to perform this action.";
    }
    
    throw error.response;
  }
},
async addRecurringScheduleData(context, payload) {
  try {
    await postReq(`app/recurring-maintenance-schedule/`, payload);
  } catch (error) {
    if (error.response && error.response.status === 403) {
      throw "You are not allowed to perform this action.";
    }
    
    throw error.response;
  }
},
async getMaintenanceScheduleExportData(_, query) {
  try {
    return await getReq(`app/maintenance-schedule/export_to_csv/${query ? "?"+query : ''}${localStorage.getItem("userSelectedCompany") ? `${query ? '&':''}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
  } catch (error) {
    if (error.response && error.response.status === 403) {
      throw "You are not allowed to perform this action.";
    }
    throw error.response;
}
},
  async addBulkMaintenanceRecords(context, payload) {
    try {
      const bulkData = await postReq(`app/maintenance/import_from_csv/?company_id=${localStorage.getItem("userSelectedCompany")}`, payload);
      return bulkData;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response.data;
    }
  },
  async extractMaintenanceFromDocument(_, payload) {
    try {
      const data = await postReq(`app/maintenance/async/extract-from-document/?company_id=${localStorage.getItem("userSelectedCompany")}`, payload);
      return data;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response ? error.response.data : error;
    }
  },
  async getAICredits(){
    try{
      const {ai_credits} = await getReq(`app/ai-credits/?company_id=${localStorage.getItem("userSelectedCompany")}`);
      return ai_credits;
    }
    catch(error){
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response ? error.response.data : error;
    }
  },
  async updateMaintenanceFromDocument(_, { maintenanceId, formData }) {
    try {
      const data = await postReq(`app/maintenance/async/extract-from-document/${maintenanceId}/?company_id=${localStorage.getItem("userSelectedCompany")}`, formData);
      return data;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response ? error.response.data : error;
    }
  },
  async getMaintenanceExtractStatus(_, asyncTaskId) {
    try {
      const data = await getReq(`app/maintenance/extract-status/${asyncTaskId}/?company_id=${localStorage.getItem("userSelectedCompany")}`);
      return data;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response ? error.response.data : error;
    }
  },
  async getMaintenanceExtractList() {
    try {
      const data = await getReq(`app/maintenance/async/extract-list/?company_id=${localStorage.getItem("userSelectedCompany")}`);
      return data;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response ? error.response.data : error;
    }
  },
  async dismissMaintenanceExtractTask(_, { id, payload }) {
    try {
      return await patchReq(`app/maintenance/async/extract-list`, id, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response ? error.response.data : error;
    }
  },
  async updateBulkEquipments(_, payload) {
    try {
      const response = await postReq("app/equipment-bulk-update/",payload);
      return response;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response;
    }
  },
  async addBulkMaintenanceSchedule(context, payload) {
    try {
      const bulkData = await postReq(`app/maintenance-schedule/import_from_csv/?company_id=${localStorage.getItem("userSelectedCompany")}`, payload);
      return bulkData;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response.data;
    }
  },
  async postMaintenance(_, payload) {
    try {
      const record = await postReq("app/maintenance/", payload);
      return record
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
  async postMaintenanceSchedule(_, payload) {
    try {
      await postReq("app/maintenance-schedule/", payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
  async patchMaintenance(_, { id, payload }) {
    try {
      await patchReq("app/maintenance", id, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
  async patchMaintenanceSchedule(_, { id, payload }) {
    try {
      return await patchReq("app/maintenance-schedule", id, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
  async deleteMaintenance(_, id) {
    try {
      await deleteReq("app/maintenance", id);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
  async deleteRecurringSchedule(_, id) {
    try {
      await deleteReq("app/recurring-maintenance-schedule", id);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
  async deleteMaintenanceSchedule(_, id) {
    try {
      await deleteReq("app/maintenance-schedule", id);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
 
  async getMaintenanceRecord({ commit }, id) {
    try{
      const maintenance = await getReq(`app/maintenance/${id}/${localStorage.getItem("userSelectedCompany") ? `?company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      commit("setCurrentMaintenance", maintenance)
    }
      catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
  async getRecurringScheduleRecord(_, id) {
    try{
      const data = await getReq(`app/recurring-maintenance-schedule/${id}/`);
      return data
    }
      catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
  async updateRecurringScheduleRecord(_, { id, payload }) {
    try {
      return await patchReq("app/recurring-maintenance-schedule", id, payload, null, false);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
  async addEquipmentBulkTags(_, payload) {
    try {
      const response = await postReq("app/equipment-add-tags-bulk/",payload);
      return response;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response;
    }
  },
  setMaintenanceSchedule({ commit }, maintenanceSchedule) {
    commit("setCurrentMaintenanceSchedule", maintenanceSchedule)
  },
  async deleteTireData(_, {equipID}) {
      try {
        return await deleteReq(`app/equipment/${equipID}/maintenance/tire-record`, '');
      } catch (error) {
        
        if (error.response && error.response.status === 403) {
          throw "You are not allowed to perform this action.";
        }
        
        throw error.response;
      }
    },
    async getAllTireTrackerData(_, payload) {
      try {
        const data = await getReq(`app/equipment/maintenance/tire-record/${payload.currentTab === 'missing' ? 'missing/' :''}${payload.url ? "?" + payload.url : ""}`);
        return data
      } catch (error) {
        
        if (error.response && error.response.status === 403) {
          throw "You are not allowed to perform this action.";
        }
        
        throw error.response;
      }
    },
    async addTireTrackerData(context, payload) {
    try {
      const newMember = await postReq(`app/equipment/${payload.equipID}/maintenance/tire-record/`, payload);
      return newMember;
      // get all team member again
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response.data;
    }
  },
  async getTireTrackerData(_, payload) {
      try {
        const data = await getReq(`app/equipment/${payload.equipID}/maintenance/tire-record/`);
        return data
      } catch (error) {
        
        if (error.response && error.response.status === 403) {
          throw "You are not allowed to perform this action.";
        }
        
        throw error.response;
      }
    },
    async updateTireTrackerData(_, payload) {
      try {
        const data = await patchReq(`app/equipment/${payload.equipID}/maintenance/tire-record`, '', payload);
        return data
      } catch (error) {
        
        if (error.response && error.response.status === 403) {
          throw "You are not allowed to perform this action.";
        }
        
        throw error.response;
      }
    },
    async monthlyMaintenanceTotal() {
    try {
      const {data}  = await getReq(`app/monthly-maintenance-total/`);
      return data;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response;
    }
  },
   async getAllMaintenaceLineItems(_, url) {
    try {
      const data = await getReq(`app/maintenance/async/line-items/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      return { records: data.data, total_pages: data.total_pages, queryset_count: data.queryset_count, total_entries: data.total_entries_count, current_page: data.current_page, total_amount: data.total_amount }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
  async getAllMaintenaceLineItemsSummary(_, url) {
    try {
      const data = await getReq(`app/maintenance/async/line-items/summary/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
  async getMaintenaceLineItemFilters() {
    try {
      const data = await getReq(`app/maintenance/async/line-items/filters/`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      
      throw error.response;
    }
  },
};

const mutations = {
  setAllEquipments: (state, allEquipments) => (state.allEquipments = allEquipments),
  setCurrentEquipment: (state, Equipment) =>
    (state.currentEquipment = Equipment),
  setEquipmentDocuments: (state, equipmentDocuments) =>
    (state.equipmentDocuments = equipmentDocuments),
  setMaintenance: (state, maintenance) => (state.maintenance = maintenance),
  setMaintenanceSchedule: (state, maintenanceSchedule) =>
    (state.maintenanceSchedule = maintenanceSchedule),
  setCurrentMaintenance: (state, currentMaintenance) => state.currentMaintenance = currentMaintenance,
  setCurrentMaintenanceSchedule: (state, currentMaintenanceSchedule) => state.currentMaintenanceSchedule = currentMaintenanceSchedule,
  setTypes: (state, types) => (state.types = types),
  setVendors: (state, vendors) => (state.vendors = vendors),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
